<mat-card-header class="todolist-header">
  <mat-card-title class="todolist-title"><b>To-Do List</b></mat-card-title>
  <div class="todolist-actions">
    <button mat-raised-button color="primary" (click)="updateList()"><span class="material-icons">
        refresh
      </span></button>
    <button mat-raised-button color="primary" (click)="addEntry()"><span class="material-icons">
        add
      </span></button>
  </div>
</mat-card-header>
<mat-card-content>
  <div *ngFor="let todoEntry of todolistEntries">
    <mat-divider></mat-divider>
    <div class="todolist-item-div">
      <div class="name-tickbox-div">
        <mat-checkbox class="todo-checkbox" [(ngModel)]="todoEntry.completed" color="primary"
          (click)="tickEntry(todoEntry)"></mat-checkbox>
        <span (click)="viewEntry(todoEntry)"
          *ngIf="todoEntry.markedNational && todoEntry.parentId == null && todoEntry.children && todoEntry.children.length > 0">
          <b>(National {{calculateNumCompleted(todoEntry)}}/{{todoEntry.children.length}})</b>
        </span>
        <span (click)="viewEntry(todoEntry)" *ngIf="!todoEntry.markedNational">
          <b>({{todoEntry.businessUnit.buId}})</b>
        </span>
        <span *ngIf="todoEntry.completed" style="text-decoration:line-through;"
          (click)="viewEntry(todoEntry)">{{todoEntry.name}}</span>
        <span *ngIf="!todoEntry.completed" (click)="viewEntry(todoEntry)">{{todoEntry.name}}</span>
      </div>
      <div class="date-delete-div">
        <div class="due-date" *ngIf="!todoEntry.completed" (click)="viewEntry(todoEntry)">
          <span class="mobile-hide">Due: {{todoEntry.dueDate | date:'dd MMMM yyyy'}}</span>
          <span class="desktop-hide">Due: {{todoEntry.dueDate | date:'dd/MM/yy'}}</span>
        </div>
        <div class="done-date" *ngIf="todoEntry.completed" (click)="viewEntry(todoEntry)">
          <span class="mobile-hide">Done: {{todoEntry.completedDate | date:'dd MMMM yyyy'}}</span>
          <span class="desktop-hide">Done: {{todoEntry.completedDate | date:'dd/MM/yy'}}</span>
        </div>
        <button class="remove-button" mat-raised-button color="warn" (click)="removeEntry(todoEntry)">X</button>
      </div>
    </div>
  </div>
</mat-card-content>
